<template>
  <div class="input-rating">
    <label
      v-for="i in 5"
      :key="i"
      class="input-rating__label"
    >
      <input
        :id="id"
        class="input-rating__input visually-hidden"
        type="radio"
        :name="name"
        :value="i"
        :checked="i === +(_value || 0)"
        :required="required"
        :disabled="disabled"
        :form="form"
        @input="handleInput"
      >

      <slot name="icon">
        <LazyIconStar class="input-rating__icon icon icon--star" />
      </slot>

      <span class="input-rating__value visually-hidden">{{ i }}</span>
    </label>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  disabled?: boolean
  form?: string
  id?: string
  name: string
  value?: number | string
  required?: boolean
}>(), {
  value: 0,
})

const _value = defineModel<number>()
_value.value = +(props.value || 0)

const emit = defineEmits(['input'])
function handleInput(event: Event) {
  _value.value = +(event.target as HTMLInputElement).value
  emit('input', (event))
}
</script>

<style>
@import url("~layers/app/components/Input/Rating.css");
</style>
